import { Modal } from '@byecode/ui'
import type { DeleteRecordActionConfig } from '@lighthouse/core'
import { FlowSelectSourceType, SelectedMode } from '@lighthouse/core'
import type { ActionFlowNode, DeleteRecordActionConfigure, FlowNodeResultADT } from '@lighthouse/shared'
import { generateVariableValue, getFindSingleRecordVariableValue, getRecordResult } from '@lighthouse/shared'
import { t } from 'i18next'

import * as srv from '@/services'

import type { ExecuteActionParams } from '../type'

export const handleDeleteRecordStream = async (
    node: ActionFlowNode<DeleteRecordActionConfigure>,
    params: ExecuteActionParams
): Promise<undefined | FlowNodeResultADT> => {
    if (!node.data.config) {
        throw new Error(t('configurationNotPerfect'))
    }

    const isSuccess = await handleDeleteRecord(node.data.config, params, true)

    if (!isSuccess) {
        throw new Error(t('deleteRecordError'))
    }
    return {
        type: 'record',
        success: isSuccess
    }
}

export const handleDeleteRecord = async (config: DeleteRecordActionConfig, params: ExecuteActionParams, fromFlow?: boolean) => {
    const { actionEvents, upstreamNodesResult } = params

    if (!fromFlow && config.confirm?.enable) {
        const isConfirm = await Modal.confirm({
            title: config.confirm.title
                ? (generateVariableValue({ innerType: 'TEXT', jsonContent: config.confirm.title, extraParams: params }) as string)
                : '',
            content: config.confirm.description
                ? (generateVariableValue({ innerType: 'TEXT', jsonContent: config.confirm.description, extraParams: params }) as string)
                : '',
            okText: config.confirm.confirmText
                ? (generateVariableValue({ innerType: 'TEXT', jsonContent: config.confirm.confirmText, extraParams: params }) as string)
                : '',
            cancelText: config.confirm.cancelText
                ? (generateVariableValue({ innerType: 'TEXT', jsonContent: config.confirm.cancelText, extraParams: params }) as string)
                : ''
        })
        if (!isConfirm) {
            return false
        }
    }

    if (config.selectType === FlowSelectSourceType.UPSTREAM) {
        const record = getRecordResult(upstreamNodesResult?.[config.nodeId])
        if (record) {
            return actionEvents.deleteRecord({ mode: SelectedMode.CURRENT_PAGE, dsId: record.dsId, recordIds: [record.id] })
        }
    }

    if (config.selectType === FlowSelectSourceType.DATASOURCE) {
        const payload = getFindSingleRecordVariableValue(config, params)
        const record = await actionEvents.findSingleRecord(payload)
        if (!record) {
            return false
        }
        // 传一个查询器给后端去做删除操作
        return actionEvents.deleteRecord({
            mode: SelectedMode.CURRENT_PAGE,
            dsId: record.dsId,
            recordIds: [record.id]
        })
    }

    return false
}
